import { render, staticRenderFns } from "./BerthChartComponent.vue?vue&type=template&id=0a6403cf&scoped=true"
import script from "./BerthChartComponent.vue?vue&type=script&lang=js"
export * from "./BerthChartComponent.vue?vue&type=script&lang=js"
import style0 from "./BerthChartComponent.vue?vue&type=style&index=0&id=0a6403cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6403cf",
  null
  
)

export default component.exports